import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getClientes, postCliente } from "../redux/actions/index";
import Swal from "sweetalert2";

const ClientesForm = () => {
  const dispatch = useDispatch();
  const clientes = useSelector((state) => state.clientes);
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [dni, setDni] = useState("");
  const [telefono, setTelefono] = useState("");

  useEffect(() => {
    dispatch(getClientes());
  }, [dispatch]);

  const handleCrearCliente = async () => {
    if (nombre && email && dni && telefono) {
      try {
        await dispatch(postCliente({ nombre, email, dni, telefono }));
        Swal.fire("Éxito", "Cliente registrado correctamente", "success");
        setNombre("");
        setEmail("");
        setDni("");
        setTelefono("");
        dispatch(getClientes());
      } catch (error) {
        Swal.fire("Error", "No se pudo registrar el cliente", "error");
      }
    } else {
      Swal.fire("Advertencia", "Todos los campos son obligatorios", "warning");
    }
  };

  return (
    <div className="grid bg-backgroundClaro grid-cols-1 md:grid-cols-2 min-h-screen h-full w-full">
      {/* Formulario de registro */}
      <div className="bg-backgroundOscuro rounded-lg m-4 p-8">
        <h1 className="text-4xl font-bold text-textoClaro mb-4">Registrar Cliente</h1>
        <div className="space-y-4">
          <div>
            <label className="text-textoClaro block mb-2">Nombre</label>
            <input
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
              placeholder="Nombre del cliente"
            />
          </div>
          <div>
            <label className="text-textoClaro block mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
              placeholder="Correo electrónico"
            />
          </div>
          <div>
            <label className="text-textoClaro block mb-2">DNI</label>
            <input
              type="text"
              value={dni}
              onChange={(e) => setDni(e.target.value)}
              className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
              placeholder="Documento de identidad"
            />
          </div>
          <div>
            <label className="text-textoClaro block mb-2">Teléfono</label>
            <input
              type="text"
              value={telefono}
              onChange={(e) => setTelefono(e.target.value)}
              className="w-full p-2 rounded bg-backgroundClaro text-textoOscuro"
              placeholder="Número de teléfono"
            />
          </div>
          <button
            onClick={handleCrearCliente}
            className="bg-green-900 w-full flex items-center justify-center my-2 p-2 rounded-md text-textoClaro font-bold text-xl hover:bg-green-600 shadow-lg shadow-green-500/50"
          >
            Registrar Cliente
          </button>
        </div>
      </div>

      {/* Lista de clientes */}
      <div className="bg-backgroundOscuro rounded-lg m-4 p-8">
        <h2 className="text-4xl font-bold text-textoClaro mb-4">Lista de Clientes</h2>
        <ul className="flex flex-wrap gap-4">
          {clientes.map((cliente) => (
            <li
              key={cliente.id}
              className="bg-backgroundClaro p-4 rounded-lg shadow-md w-full lg:w-[calc(50%-1rem)]"
              >
              <h3 className="text-textoOscuro font-semibold">{cliente.nombre}</h3>
              <p className="text-textoOscuro">Email: {cliente.email}</p>
              <p className="text-textoOscuro">DNI: {cliente.dni}</p>
              <p className="text-textoOscuro">Teléfono: {cliente.telefono}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ClientesForm;
